import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import ZipperOverlay from "./ZipperOverlay";
import { playZip } from "@/lib/zipSound";

/* Plays a quick zipper-open reveal on every route change. */
export default function RouteZipper() {
    const { pathname } = useLocation();
    const first = useRef(true);
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (first.current) {
            first.current = false;
            return;
        }
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        playZip({ rate: 0.9, volume: 0.12 });
        setShow(true);
    }, [pathname]);

    return <ZipperOverlay show={show} onDone={() => setShow(false)} />;
}
